import type { Me } from "@bioflow/contracts";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { home } from "../content/site";
import { GOAL_LABELS, formatBmi, hasBodyData } from "../lib/profile";
import { hasTelegramContext } from "../lib/telegram";

/**
 * Персональный блок на главной (экран 8): цель, текущий вес и BMI из
 * профиля. Вне Telegram профиля нет — блок не показывается вовсе, чтобы
 * не звать заполнять данные там, где их некуда сохранить.
 */
export function PersonalBlock({ me }: { me: Me | undefined }) {
  const navigate = useNavigate();
  if (!hasTelegramContext()) return null;

  const profile = me?.profile;
  const filled = hasBodyData(profile) || Boolean(profile?.goal);

  return (
    <section className="block">
      <h2 className="block__title">{home.personal.title}</h2>
      <div className="personal">
        {filled ? (
          <>
            <div className="personal__grid">
              <div className="personal__cell personal__cell--wide">
                <span className="personal__label">{home.personal.goal}</span>
                <strong>{profile?.goal ? GOAL_LABELS[profile.goal] : "—"}</strong>
              </div>
              <div className="personal__cell">
                <span className="personal__label">{home.personal.weight}</span>
                <strong>{profile?.weightKg !== null && profile?.weightKg !== undefined ? `${profile.weightKg} кг` : "—"}</strong>
              </div>
              <div className="personal__cell">
                <span className="personal__label">{home.personal.bmi}</span>
                <strong>{profile?.bmi !== null && profile?.bmi !== undefined ? formatBmi(profile.bmi) : "—"}</strong>
              </div>
            </div>
            <button type="button" className="button button--ghost" onClick={() => navigate("/profile/edit")}>
              <Pencil size={16} strokeWidth={2} aria-hidden /> {home.personal.edit}
            </button>
          </>
        ) : (
          <>
            <p className="muted small">{home.personal.empty}</p>
            <button type="button" className="button button--ghost" onClick={() => navigate("/profile/edit")}>
              {home.personal.fill}
            </button>
          </>
        )}
      </div>
    </section>
  );
}
